// extracted by mini-css-extract-plugin
module.exports = {"fontSizeTitle":"24px","fontSizeHeader":"20px","fontSizeSubheader":"16px","fontSizeBody":"15px","fontSizeMedium":"13px","fontSizeSmall":"12px","spacerChart":"14px"};